module.exports = "<list-user-assignment-template [workwaveId]=\"idWorkwave\"></list-user-assignment-template>\n"